export function IconBadge({ children, dark = false }: { children: React.ReactNode; dark?: boolean }) {
  return (
    <div
      className={
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl text-sm font-semibold shadow-sm " +
        (dark ? "bg-stone-900 text-white" : "bg-stone-100 text-stone-600")
      }
      data-testid="icon-badge"
    >
      {children}
    </div>
  );
}
